import React from"react";export function usePrevious(a){var b=React.useRef(a);return React.useEffect(function(){b.current=a},[a]),b.current}
//# sourceMappingURL=usePrevious.js.map